import { BoundCheckBox } from "lib/@components/standard-checkbox"
import { BlockClicks } from "lib/@components/block-clicks"
import { Tooltip } from "@mui/material"
import { RegimeDraftLockTooltip } from "../regime-draft-locking/regime-draft-lock-tooltip"
import { KeepZeroUTitle } from "./keep-zero-u-title"

export function KeepZeroU() {
    return (
        <Tooltip arrow title={<KeepZeroUTitle />}>
            <BlockClicks>
                <RegimeDraftLockTooltip>
                    <BoundCheckBox field="suppressZeroU" label="Confirm 0U" />
                </RegimeDraftLockTooltip>
            </BlockClicks>
        </Tooltip>
    )
}
